// extracted by mini-css-extract-plugin
export default {"container":"qj-z","blurb":"rj-z","links":"sj-z"};